function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7-19h18a1 1 0 1 1 0 2H11a1 1 0 1 1 0-2zm0 8h18a1 1 0 1 1 0 2H11a1 1 0 1 1 0-2zm0 8h18a1 1 0 1 1 0 2H11a1 1 0 1 1 0-2z"
});

var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "1e90fc73c2cff9a93b3f788fcb185e46.svg";
export { SvgList as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/list.svg
// module id = null
// module chunks = 